
import { deserialize } from "serializr";
import _axiosInstance from "../../interceptor/_axiosInstance";
import { Subscription } from "../../models/SubscriptionModel/subscription.model";
import { STUDENT_SUBSCRIPTIONS } from "../../routes/routeConstants/apiRoutes";

export class SubscriptionsService {
  static fetchSubscriptions(
    StudentId: number,
    onSuccess: (value: Subscription[]) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return _axiosInstance
      .get(STUDENT_SUBSCRIPTIONS, {
        params: {
          'Studentid': StudentId
        }
      })
      .then((response) => {
        const data = deserialize(Subscription, response?.data["subscription"]);
         onSuccess(data as Subscription[]);
      })
      .catch((e) => {
        console.log(e);
        onError(e);
      })
      .finally(onFinal);
  }
}
